module.exports = __webpack_public_path__ + "img/beef-1.af519243.jpg";